var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.098,
    height: 36.098,
    viewBox: "0 0 36.098 36.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3071853_chip_computer_cpu_device_digital_icon",
    "data-name": "3071853_chip_computer_cpu_device_digital_icon",
    d: "M31.965,41.26h8.167a1.128,1.128,0,0,0,1.128-1.128V31.965a1.128,1.128,0,0,0-1.128-1.128H31.965a1.128,1.128,0,0,0-1.128,1.128v8.167A1.128,1.128,0,0,0,31.965,41.26Zm1.128-8.167H39V39H33.093ZM52.97,37.177a1.128,1.128,0,0,0,0-2.256H48.931V29.185H52.97a1.128,1.128,0,0,0,0-2.256H48.931V24.295A1.128,1.128,0,0,0,47.8,23.166H45.169V19.128a1.128,1.128,0,0,0-2.256,0v4.038H37.177V19.128a1.128,1.128,0,0,0-2.256,0v4.038H29.185V19.128a1.128,1.128,0,0,0-2.256,0v4.038H24.295a1.128,1.128,0,0,0-1.128,1.128v2.634H19.128a1.128,1.128,0,0,0,0,2.256h4.038v5.736H19.128a1.128,1.128,0,0,0,0,2.256h4.038v5.736H19.128a1.128,1.128,0,0,0,0,2.256h4.038V47.8a1.128,1.128,0,0,0,1.128,1.128h2.634V52.97a1.128,1.128,0,0,0,2.256,0V48.931h5.736V52.97a1.128,1.128,0,0,0,2.256,0V48.931h5.736V52.97a1.128,1.128,0,0,0,2.256,0V48.931H47.8A1.128,1.128,0,0,0,48.931,47.8V45.169H52.97a1.128,1.128,0,0,0,0-2.256H48.931V37.177Zm-6.295,9.5H25.423V25.423H46.675Z",
    transform: "translate(-18 -18)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.80b1bc83c64790787a7e04370bd794e0.svg";
export { ForwardRef as ReactComponent };